import { render, staticRenderFns } from "./prd_catlist.vue?vue&type=template&id=d926aa9c&scoped=true"
import script from "./prd_catlist.vue?vue&type=script&lang=js"
export * from "./prd_catlist.vue?vue&type=script&lang=js"
import style0 from "./prd_catlist.vue?vue&type=style&index=0&id=d926aa9c&prod&lang=less"
import style1 from "./prd_catlist.vue?vue&type=style&index=1&id=d926aa9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d926aa9c",
  null
  
)

export default component.exports